export default "__VITE_ASSET__YwP8Mh1D__"